'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchBar = require('./components/SearchBar.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/search-bar/index.js
// module id = 922
// module chunks = 0